import { forwardRef } from "react";
import { Trophy, Medal, Star } from "lucide-react";

/**
 * Branded 1080x1350 (rendered 540x675, exported @2x) franchise card
 * for auction-night sharing to WhatsApp / Instagram.
 */
const TeamCard = forwardRef(function TeamCard({ card }, ref) {
  return (
    <div
      ref={ref}
      data-testid="team-stat-card"
      className="relative w-[540px] h-[675px] overflow-hidden font-sans"
      style={{
        background: "radial-gradient(ellipse 90% 60% at 50% -10%, #004aad 0%, rgba(0,74,173,0) 60%), #090a0b",
        color: "#ffffff",
      }}
    >
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 8, background: "#ff3b30" }} />

      <div className="flex items-center gap-3 px-10 pt-10">
        <img src="/asl-logo-white.png" alt="" className="h-12 w-auto" crossOrigin="anonymous" />
        <div>
          <p className="font-display text-xl tracking-wide leading-none">ALL STAR LEAGUE</p>
          <p className="text-[10px] font-bold uppercase tracking-[0.3em] mt-1.5" style={{ color: "#ff3b30" }}>Season 6 Franchise</p>
        </div>
        <div className="ml-auto text-right">
          <p className="font-oswald text-base font-semibold" style={{ color: "rgba(255,255,255,0.5)" }}>{card.seasons_active} season{card.seasons_active > 1 ? "s" : ""}</p>
          <p className="text-[10px] font-bold uppercase tracking-[0.25em] mt-1" style={{ color: "rgba(255,255,255,0.3)" }}>Franchise Legacy</p>
        </div>
      </div>

      <div className="px-10 mt-12">
        <p className="font-display text-[52px] tracking-tight leading-[1.02]">{card.team.toUpperCase()}</p>
        {card.titles.length > 0 ? (
          <div className="mt-5 flex flex-wrap gap-2.5">
            {card.titles.map((s) => (
              <span key={`t${s}`} className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-widest" style={{ background: "rgba(251,191,36,0.15)", border: "1px solid rgba(251,191,36,0.5)", color: "#fbbf24" }}>
                <Trophy size={12} /> Champion S{s}.0
              </span>
            ))}
            {card.runners.map((s) => (
              <span key={`r${s}`} className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-widest" style={{ background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.2)", color: "rgba(255,255,255,0.7)" }}>
                <Medal size={12} /> Runner-up S{s}.0
              </span>
            ))}
          </div>
        ) : (
          <p className="mt-5 text-xs font-bold uppercase tracking-[0.25em]" style={{ color: "rgba(255,255,255,0.45)" }}>
            Hunting a first title in 6.0
          </p>
        )}
      </div>

      <div className="px-10 mt-10 grid grid-cols-4 gap-3.5">
        {[
          ["Runs", card.runs],
          ["Wickets", card.wickets],
          ["Dismissals", card.dismissals],
          ["MVP Pts", card.mvp_points],
        ].map(([label, val]) => (
          <div key={label} className="rounded-xl px-2 py-6 text-center" style={{ background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)" }}>
            <p className="font-oswald text-3xl font-semibold leading-none" style={{ color: "#ff3b30" }}>{val}</p>
            <p className="text-[10px] font-bold uppercase tracking-[0.2em] mt-2.5" style={{ color: "rgba(255,255,255,0.45)" }}>{label}</p>
          </div>
        ))}
      </div>

      {card.top_star && (
        <div className="px-10 mt-9">
          <div className="rounded-xl px-5 py-4 flex items-center gap-4" style={{ background: "rgba(0,74,173,0.25)", border: "1px solid rgba(0,74,173,0.6)" }}>
            <Star size={20} style={{ color: "#fbbf24" }} />
            <div>
              <p className="text-[9px] font-bold uppercase tracking-[0.3em]" style={{ color: "rgba(255,255,255,0.45)" }}>Franchise Star</p>
              <p className="font-oswald text-xl font-semibold leading-tight mt-0.5">{card.top_star.player}</p>
            </div>
            <p className="ml-auto font-oswald text-lg font-semibold" style={{ color: "#ff3b30" }}>{card.top_star.points} <span className="text-[10px] uppercase tracking-widest" style={{ color: "rgba(255,255,255,0.4)" }}>MVP pts</span></p>
          </div>
        </div>
      )}

      <div className="absolute bottom-0 left-0 right-0 px-10 py-6 flex items-center justify-between" style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}>
        <p className="text-[11px] font-bold uppercase tracking-[0.25em]" style={{ color: "rgba(255,255,255,0.4)" }}>
          Auction Night • ASL 6.0 • Surat
        </p>
        <p className="text-[11px] font-bold uppercase tracking-[0.25em]" style={{ color: "#ff3b30" }}>
          19–21 Feb 2027
        </p>
      </div>
    </div>
  );
});

export default TeamCard;
